export default "__VITE_ASSET__D1YAhCJ7__"